import { AuthContext } from '@auth/contexts/AuthProvider';
import { appEnv } from '@src/env';
import mixpanel, { Dict } from 'mixpanel-browser';
import { useContext } from 'react';
import { TrackingEventName, TrackingEventProperties } from './trackingEventTaxonomy';

mixpanel.init(appEnv.VITE_MIXPANEL_PROJECT_KEY, { track_pageview: false, persistence: 'localStorage' });

const isHumanUser = (email?: string | null) => !email?.includes('+ci@ocula.tech');

export type EventActions = {
  identify: (id: string | undefined) => void;
  alias: (id: string) => void;
  track: (name: TrackingEventName, props: TrackingEventProperties) => void;
  people: {
    set: (props: Dict) => void;
  };
};

const useMixpanel = (email?: string | null): EventActions => {
  const developmentOrUnitTest =
    !process.env.NODE_ENV || process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
  const shouldTrack = isHumanUser(email) && !developmentOrUnitTest;

  return {
    identify: (id: string | undefined) => {
      if (shouldTrack) mixpanel.identify(id);
    },
    alias: (id: string) => {
      if (shouldTrack) mixpanel.alias(id);
    },
    track: (name: TrackingEventName, props: TrackingEventProperties) => {
      if (shouldTrack) mixpanel.track(name, props);
    },
    people: {
      set: (props: Dict) => {
        if (shouldTrack) mixpanel.people.set(props);
      },
    },
  };
};

// Composing hook that gets email from auth context
export const useTracking = () => {
  const auth = useContext(AuthContext);
  return useMixpanel(auth?.user?.email);
};
